import { RX } from '../../constants/rx';
import { VERIFY_AUCTION_ACCESS } from '../../constants/resources';
import { VALIDATION_ERROR_MESSAGES } from '../../../../shared/js/constants';
import { getVerifyAuctionAccessFormValidation } from './validations';
import classNames from 'classnames';

const { flex } = window;
const {
    React,
    ReactAddons: { PropTypes }
} = flex.lib;

const {
    FormsyPrismInput,
    PrismLabel,
    PrismMessage,
    PrismIcon,
    PrismLink,
    PrismButton
} = flex.components;

class VerifyAuctionAccess extends React.Component {
    static propTypes = {
        verifyAuctionAccess: PropTypes.shape({
            wasInviteExpired: PropTypes.bool
        }),
        registrationToken: PropTypes.string.isRequired
    };

    static defaultProps = {
        verifyAuctionAccess: {
            wasInviteExpired: false
        }
    };

    state = {
        formValid: false,
        showInfoMessage: false
    };

    componentDidMount() {
        flex.trigger(RX.VERIFY_AUCTION_ACCESS.CLEAR_BRANCH);
    }

    handleInfoIconClick = () => {
        this.setState({ showInfoMessage: !this.state.showInfoMessage });
    }

    enableFormSubmit = () => this.setState({ formValid: true });

    disableFormSubmit = () => this.setState({ formValid: false });

    onSubmit = ({ auctionAccessId, governmentIssuedId }) => {
        const { registrationToken } = this.props;

        flex.trigger(
            RX.VERIFY_AUCTION_ACCESS.SUBMIT_FORM,
            auctionAccessId,
            governmentIssuedId,
            registrationToken
        );
    }

    render() {
        const { showInfoMessage, formValid } = this.state;
        const { wasInviteExpired } = this.props.verifyAuctionAccess;

        const { auctionAccessIdValidation, governmentIssuedIdValidation } = getVerifyAuctionAccessFormValidation();

        const messageClassName = classNames(
            'verify-auction-access__info-message',
            { 'verify-auction-access__info-message_hidden': !showInfoMessage }
        );

        const isSubmitDisabled = !formValid
            || wasInviteExpired
            || flex.isBusy(RX.VERIFY_AUCTION_ACCESS.SUBMIT_FORM);

        return (
            <section className="container verify-auction-access">
                <header>
                    <h1 className="verify-auction-access__header">
                        {VERIFY_AUCTION_ACCESS.HEADER}
                    </h1>
                </header>
                <div className="verify-auction-access__form-container">
                    <flex.lib.Formsy.Form
                        onValidSubmit={this.onSubmit}
                        onValid={this.enableFormSubmit}
                        onInvalid={this.disableFormSubmit}
                    >
                        <PrismMessage
                            className={messageClassName}
                            color="info"
                        >
                            {VERIFY_AUCTION_ACCESS.HELP_MSG}
                        </PrismMessage>
                        <FormsyPrismInput
                            id="auctionAccessId"
                            name="auctionAccessId"
                            label={(
                                <div className="verify-auction-access__label-container">
                                    <PrismLabel for="auctionAccessId">
                                        {`${VERIFY_AUCTION_ACCESS.AA1M_FIELD_LBL}*`}
                                    </PrismLabel>
                                    <PrismIcon
                                        className="verify-auction-access__info-icon"
                                        glyph="info"
                                        onClick={this.handleInfoIconClick}
                                    />
                                    <PrismLink
                                        className="verify-auction-access__link-container"
                                        size="sm"
                                        target="_blank"
                                        href="https://www.auctionaccess.com/"
                                    >
                                        {VERIFY_AUCTION_ACCESS.AA_LINK_TEXT}
                                    </PrismLink>
                                </div>
                            )}
                            placeholder={VERIFY_AUCTION_ACCESS.AA1M_FIELD_PLACEHOLDER}
                            autofocus
                            required
                            validations={auctionAccessIdValidation.validators}
                            validationError={VALIDATION_ERROR_MESSAGES.REQUIRED(VERIFY_AUCTION_ACCESS.AA1M_FIELD)}
                            validationErrors={auctionAccessIdValidation.errorMessages}
                        />
                        <FormsyPrismInput
                            id="governmentIssuedId"
                            inputClassName="verify-auction-access__issued-id-input"
                            name="governmentIssuedId"
                            label={VERIFY_AUCTION_ACCESS.GOV_ID_FIELD_LBL}
                            placeholder={VERIFY_AUCTION_ACCESS.GOV_ID_FIELD_PLACEHOLDER}
                            help={VERIFY_AUCTION_ACCESS.GOV_ID_FIELD_HELP}
                            required
                            validations={governmentIssuedIdValidation.validators}
                            validationError={VALIDATION_ERROR_MESSAGES.REQUIRED(VERIFY_AUCTION_ACCESS.GOV_ID_FIELD)}
                            validationErrors={governmentIssuedIdValidation.errorMessages}
                        />
                        <PrismButton
                            outline
                            type="submit"
                            className="verify-auction-access__submit-container"
                            buttonClassName="verify-auction-access__submit-button"
                            disabled={isSubmitDisabled}
                        >
                            {VERIFY_AUCTION_ACCESS.FORM_SUBMIT_BTN}
                        </PrismButton>
                    </flex.lib.Formsy.Form>
                </div>
            </section>
        );
    }
}

export default VerifyAuctionAccess;
